const chapter = {
  id: 'permutations-combinations',
  slug: 'permutations-combinations',
  subject: 'mathematics',
  subjectLabel: 'Mathematics',
  exam: 'JEE Main + Advanced',
  title: {
    english: 'Permutations & Combinations',
        hindi: 'क्रमचय और संचय',
  },
  estReadMinutes: 55,
  difficulty: {
    english: 'Medium-Hard',
        hindi: 'मध्यम-कठिन',
  },
  weightage: {
    english: '2 questions in JEE Main, 1 in Advanced',
        hindi: 'जेईई मेन में 2 प्रश्न, एडवांस्ड में 1 प्रश्न',
  },
  syllabusTags: ['Algebra', 'JEE-Main', 'JEE-Advanced', 'Class-11'],
  sections: [
    {
      id: 'fpc',
      title: {
        english: 'Fundamental Principle of Counting',
        hindi: 'गणना का मूल सिद्धान्त',
      },
      blocks: [
        {
          type: 'definition',
          term: {
            english: 'Multiplication Principle (AND)',
        hindi: 'गुणन सिद्धांत (और)',
          },
          body: {
            english: 'If an event $E_1$ can occur in $m$ ways and, **for each** of these, $E_2$ can occur in $n$ ways, then $E_1$ **and** $E_2$ can occur in $m \\times n$ ways.',
        hindi: 'यदि कोई घटना $E_1$ $m$ तरीकों से घटित हो सकती है और, **इनमें से प्रत्येक** के लिए, $E_2$ $n$ तरीकों से घटित हो सकती है, तो $E_1$ **और** $E_2$ $m \\times n$ तरीकों से घटित हो सकती है।',
          },
        },
        {
          type: 'definition',
          term: {
            english: 'Addition Principle (OR)',
        hindi: 'अतिरिक्त सिद्धांत (OR)',
          },
          body: {
            english: 'If $E_1$ can occur in $m$ ways and $E_2$ can occur in $n$ ways and the two events are **mutually exclusive**, then $E_1$ **or** $E_2$ can occur in $m + n$ ways.',
        hindi: 'यदि $E_1$ $m$ तरीकों से घटित हो सकता है और $E_2$ $n$ तरीकों से घटित हो सकता है और दोनों घटनाएं **परस्पर अनन्य** हैं, तो $E_1$ **या** $E_2$ $m + n$ में घटित हो सकती हैं तरीके. **सामान्य नियम**: "और" → गुणा करें; "या" → जोड़ें. इन्हें गलत तरीके से लागू करना P&C त्रुटियों का #1 स्रोत है।',
          },
        },
        {
          type: 'tip',
          text: {
            english: '**Rule of thumb**: "AND" → multiply; "OR" → add. Mis-applying these is the #1 source of P&C errors.',
        hindi: '**अंगूठे का नियम**: "और" → गुणा; "या" → जोड़ें. इन्हें गलत तरीके से लागू करना P&C त्रुटियों का #1 स्रोत है।',
          },
        },
        {
          type: 'figure',
          svg: `
<svg viewBox="0 0 480 240" xmlns="http://www.w3.org/2000/svg">
  <line x1="240" y1="40" x2="90" y2="78" stroke="#9ca3af"/>
  <line x1="240" y1="40" x2="240" y2="78" stroke="#9ca3af"/>
  <line x1="240" y1="40" x2="390" y2="78" stroke="#9ca3af"/>
  <line x1="90" y1="102" x2="50" y2="148" stroke="#9ca3af"/>
  <line x1="90" y1="102" x2="130" y2="148" stroke="#9ca3af"/>
  <line x1="240" y1="102" x2="200" y2="148" stroke="#9ca3af"/>
  <line x1="240" y1="102" x2="280" y2="148" stroke="#9ca3af"/>
  <line x1="390" y1="102" x2="350" y2="148" stroke="#9ca3af"/>
  <line x1="390" y1="102" x2="430" y2="148" stroke="#9ca3af"/>
  <line x1="50" y1="172" x2="50" y2="203" stroke="#9ca3af"/>
  <line x1="130" y1="172" x2="130" y2="203" stroke="#9ca3af"/>
  <line x1="200" y1="172" x2="200" y2="203" stroke="#9ca3af"/>
  <line x1="280" y1="172" x2="280" y2="203" stroke="#9ca3af"/>
  <line x1="350" y1="172" x2="350" y2="203" stroke="#9ca3af"/>
  <line x1="430" y1="172" x2="430" y2="203" stroke="#9ca3af"/>
  <circle cx="240" cy="28" r="13" fill="#fef3c7" stroke="#374151"/><text x="240" y="32" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">·</text>
  <circle cx="90" cy="90" r="13" fill="#dbeafe" stroke="#374151"/><text x="90" y="94" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">A</text>
  <circle cx="240" cy="90" r="13" fill="#dbeafe" stroke="#374151"/><text x="240" y="94" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">B</text>
  <circle cx="390" cy="90" r="13" fill="#dbeafe" stroke="#374151"/><text x="390" y="94" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">C</text>
  <circle cx="50" cy="160" r="13" fill="#fce7f3" stroke="#374151"/><text x="50" y="164" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">B</text>
  <circle cx="130" cy="160" r="13" fill="#fce7f3" stroke="#374151"/><text x="130" y="164" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">C</text>
  <circle cx="200" cy="160" r="13" fill="#fce7f3" stroke="#374151"/><text x="200" y="164" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">A</text>
  <circle cx="280" cy="160" r="13" fill="#fce7f3" stroke="#374151"/><text x="280" y="164" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">C</text>
  <circle cx="350" cy="160" r="13" fill="#fce7f3" stroke="#374151"/><text x="350" y="164" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">A</text>
  <circle cx="430" cy="160" r="13" fill="#fce7f3" stroke="#374151"/><text x="430" y="164" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">B</text>
  <circle cx="50" cy="215" r="13" fill="#d1fae5" stroke="#374151"/><text x="50" y="219" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">C</text>
  <circle cx="130" cy="215" r="13" fill="#d1fae5" stroke="#374151"/><text x="130" y="219" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">B</text>
  <circle cx="200" cy="215" r="13" fill="#d1fae5" stroke="#374151"/><text x="200" y="219" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">C</text>
  <circle cx="280" cy="215" r="13" fill="#d1fae5" stroke="#374151"/><text x="280" y="219" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">A</text>
  <circle cx="350" cy="215" r="13" fill="#d1fae5" stroke="#374151"/><text x="350" y="219" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">B</text>
  <circle cx="430" cy="215" r="13" fill="#d1fae5" stroke="#374151"/><text x="430" y="219" font-size="12" text-anchor="middle" fill="#1f2937" font-weight="600">A</text>
</svg>`,
          caption: {
            english: 'Tree of arrangements of {A,B,C}: 3 choices, then 2, then 1 → 3·2·1 = 6 leaves = 6 permutations.',
        hindi: '{A,B,C} की व्यवस्था का वृक्ष: 3 विकल्प, फिर 2, फिर 1 → 3·2·1 = 6 leaves = 6 permutations।',
          },
        },
        {
          type: 'example',
          number: 1,
          problem: {
            english: 'How many 3-digit numbers can be formed using digits 1, 2, 3, 4, 5 if repetition is allowed?',
        hindi: 'यदि पुनरावृत्ति की अनुमति हो तो अंक 1, 2, 3, 4, 5 का उपयोग करके कितनी तीन अंकों की संख्याएँ बनाई जा सकती हैं?',
          },
          solution: {
            english: 'Hundreds place: 5 choices, tens: 5, units: 5. Total $= 5 \\times 5 \\times 5 = 125$.',
        hindi: 'सैकड़ों स्थान: 5 विकल्प, दहाई: 5, इकाइयाँ: 5. कुल $= 5 \\times 5 \\times 5 = 125$।',
          },
        },
      ],
    },
    {
      id: 'factorial',
      title: {
        english: 'Factorial Notation',
        hindi: 'क्रमगुणित संकेत',
      },
      blocks: [
        {
          type: 'definition',
          term: {
            english: 'Factorial',
        hindi: 'फैक्टोरियल',
          },
          body: {
            english: 'For $n \\in \\mathbb{N}$,  $n! = n \\cdot (n-1) \\cdot (n-2) \\cdots 2 \\cdot 1$. By convention, $0! = 1$.',
        hindi: '$n \\in \\mathbb{N}$, $n! = n \\cdot (n-1) \\cdot (n-2) \\cdots 2 \\cdot 1$ के लिए। परंपरा के अनुसार, $0! = 1$।',
          },
        },
        {
          type: 'equation',
          latex: 'n! = n \\cdot (n-1)!',
        },
        {
          type: 'list',
          items: [
            {
              english: '$1! = 1,\\ 2! = 2,\\ 3! = 6,\\ 4! = 24,\\ 5! = 120,\\ 6! = 720,\\ 7! = 5040$.',
        hindi: '$1! = 1,\\ 2! = 2,\\ 3! = 6,\\4! = 24,\\ 5! = 120,\\ 6! = 720,\\ 7! = 5040$.',
            },
            {
              english: 'Factorials grow very fast — useful in approximations and limits.',
        hindi: 'फैक्टोरियल बहुत तेजी से बढ़ते हैं - अनुमान और सीमा में उपयोगी।',
            },
            {
              english: 'For prime $p$, the exponent of $p$ in $n!$ is $\\sum_{k=1}^{\\infty} \\lfloor n/p^k \\rfloor$ (**Legendre\'s formula**).',
        hindi: 'अभाज्य $p$ के लिए, $n!$ में $p$ का घातांक $\\sum_{k=1}^{\\infty} \\lfloor n/p^k \\rfloor$ (**लीजेन्ड्रे का सूत्र**) है।',
            },
          ],
        },
      ],
    },
    {
      id: 'permutations',
      title: {
        english: 'Permutations',
        hindi: 'क्रमचय',
      },
      blocks: [
        {
          type: 'definition',
          term: {
            english: 'Permutation',
        hindi: 'क्रमपरिवर्तन',
          },
          body: {
            english: 'A **permutation** is an arrangement of objects in a definite order. The number of permutations of $n$ distinct objects taken $r$ at a time (no repetition) is denoted $^nP_r$ or $P(n,r)$.',
        hindi: '**क्रमपरिवर्तन** एक निश्चित क्रम में वस्तुओं की व्यवस्था है। एक समय में $r$ ली गई $n$ विशिष्ट वस्तुओं के क्रमपरिवर्तन की संख्या (कोई पुनरावृत्ति नहीं) को $^nP_r$ या $P(n,r)$ दर्शाया जाता है।',
          },
        },
        {
          type: 'equation',
          latex: '^nP_r = \\dfrac{n!}{(n - r)!},\\quad 0 \\le r \\le n',
        },
        {
          type: 'list',
          items: [
            {
              english: '$^nP_n = n!$ — arrangements of all $n$ objects.',
        hindi: '$^nP_n = n!$ — सभी $n$ वस्तुओं की व्यवस्था।',
            },
            {
              english: 'Permutations of $n$ objects when **repetition is allowed**: $n^r$.',
        hindi: '$n$ वस्तुओं का क्रमपरिवर्तन जब **दोहराव की अनुमति है**: $n^r$।',
            },
            {
              english: 'Permutations of $n$ objects, of which $p$ are alike of one kind, $q$ alike of another etc: $\\dfrac{n!}{p!\\,q!\\,\\ldots}$',
        hindi: '$n$ वस्तुओं के क्रमपरिवर्तन, जिनमें से $p$ एक प्रकार के समान हैं, $q$ दूसरे प्रकार के समान हैं आदि: $\\dfrac{n!}{p!\\,q!\\,\\ldots}$',
            },
          ],
        },
        {
          type: 'theorem',
          name: {
            english: 'Circular Permutations',
        hindi: 'वृत्ताकार क्रमपरिवर्तन',
          },
          statement: {
            english: `Number of circular arrangements of $n$ distinct objects is $(n-1)!$.
If clockwise and anti-clockwise are treated **same** (e.g. necklace), it becomes $\\dfrac{(n-1)!}{2}$.`,
            hindi: '$n$ विशिष्ट वस्तुओं की गोलाकार व्यवस्था की संख्या $(n-1)!$ है। यदि दक्षिणावर्त और वामावर्त को **समान** माना जाए (जैसे हार), तो यह $\\dfrac{(n-1)!}{2}$ हो जाता है।',
          },
        },
        {
          type: 'example',
          number: 2,
          problem: {
            english: 'In how many ways can the letters of MISSISSIPPI be arranged?',
        hindi: 'MISSISSIPPI के अक्षरों को कितने तरीकों से व्यवस्थित किया जा सकता है?',
          },
          solution: {
            english: '11 letters: M(1), I(4), S(4), P(2). $\\dfrac{11!}{1!\\,4!\\,4!\\,2!} = \\dfrac{39916800}{1 \\cdot 24 \\cdot 24 \\cdot 2} = 34650$.',
        hindi: '11 अक्षर: एम(1), आई(4), एस(4), पी(2)। $\\dfrac{11!}{1!\\,4!\\,4!\\,2!} = \\dfrac{39916800}{1 \\cdot 24 \\cdot 24 \\cdot 2} = 34650$.',
          },
        },
        {
          type: 'example',
          number: 3,
          problem: {
            english: 'In how many ways can 6 people sit around a circular table?',
        hindi: 'एक गोलाकार मेज के चारों ओर 6 लोग कितने तरीकों से बैठ सकते हैं?',
          },
          solution: {
            english: '$(6 - 1)! = 5! = 120$.',
        hindi: '$(6 - 1)! = 5! = 120$.',
          },
        },
      ],
    },
    {
      id: 'combinations',
      title: {
        english: 'Combinations',
        hindi: 'संचय',
      },
      blocks: [
        {
          type: 'definition',
          term: {
            english: 'Combination',
        hindi: 'संयोजन',
          },
          body: {
            english: 'A **combination** is a selection of objects without regard to order. The number of combinations of $n$ distinct objects taken $r$ at a time is $^nC_r$ or $\\binom{n}{r}$.',
        hindi: 'एक **संयोजन** क्रम की परवाह किए बिना वस्तुओं का चयन है। एक समय में $r$ ली गई $n$ विशिष्ट वस्तुओं के संयोजन की संख्या $^nC_r$ या $\\binom{n}{r}$ है।',
          },
        },
        {
          type: 'equation',
          latex: '^nC_r = \\dfrac{n!}{r!\\,(n - r)!} = \\dfrac{^nP_r}{r!}',
        },
        {
          type: 'table',
          headers: ['Property', 'Formula'],
          rows: [
            ['Symmetry', '$^nC_r = ^nC_{n-r}$'],
            ['Pascal', '$^nC_r + ^nC_{r-1} = ^{n+1}C_r$'],
            ['Total subsets', '$^nC_0 + ^nC_1 + \\ldots + ^nC_n = 2^n$'],
            ['$^nC_r = ^nC_s$', '$r = s$ **or** $r + s = n$'],
            ['Boundary', '$^nC_0 = ^nC_n = 1$'],
            ['Identity', '$r \\cdot ^nC_r = n \\cdot ^{n-1}C_{r-1}$'],
          ],
        },
        {
          type: 'tip',
          text: {
            english: '**Permutation vs Combination**: if order matters, use $^nP_r$; if only selection matters, use $^nC_r$. Note $^nP_r = r! \\cdot ^nC_r$.',
        hindi: '**क्रमपरिवर्तन बनाम संयोजन**: यदि क्रम मायने रखता है, तो $^nP_r$ का उपयोग करें; यदि केवल चयन मायने रखता है, तो $^nC_r$ का उपयोग करें। नोट $^nP_r = r! \\cdot ^nC_r$.',
          },
        },
        {
          type: 'example',
          number: 4,
          problem: {
            english: 'A committee of 5 is to be formed from 7 men and 5 women. In how many ways can it be formed if it must contain at least 3 women?',
        hindi: '7 पुरुषों और 5 महिलाओं से 5 की एक समिति बनाई जानी है। यदि इसमें कम से कम 3 महिलाएँ हों तो इसे कितने तरीकों से बनाया जा सकता है?',
          },
          solution: {
            english: `Cases: (3W, 2M), (4W, 1M), (5W, 0M).
$\\binom{5}{3}\\binom{7}{2} + \\binom{5}{4}\\binom{7}{1} + \\binom{5}{5}\\binom{7}{0}$
$= 10 \\cdot 21 + 5 \\cdot 7 + 1 \\cdot 1 = 210 + 35 + 1 = 246$.`,
            hindi: 'मामले: (3W, 2M), (4W, 1M), (5W, 0M)। $\\binom{5}{3}\\binom{7}{2} + \\binom{5}{4}\\binom{7}{1} + \\binom{5}{5}\\binom{7}{0}$ $= 10 \\cdot 21 + 5 \\cdot 7 + 1 \\cdot 1 = 210 + 35 + 1 = 246$.',
          },
        },
      ],
    },
    {
      id: 'distribution',
      title: {
        english: 'Distribution & Division of Objects',
        hindi: 'वस्तुओं का वितरण और विभाजन',
      },
      blocks: [
        {
          type: 'theorem',
          name: {
            english: 'Division into groups',
        hindi: 'समूहों में विभाजन',
          },
          statement: {
            english: `Number of ways to divide $n$ distinct objects into $k$ groups of sizes $n_1, n_2, \\ldots, n_k$ (with $\\sum n_i = n$):
• If groups are **distinguishable**: $\\dfrac{n!}{n_1!\\,n_2!\\cdots n_k!}$.
• If groups are **identical** and all sizes equal $m$ (so $n = km$): $\\dfrac{n!}{(m!)^k \\cdot k!}$.`,
            hindi: '$n$ विशिष्ट वस्तुओं को $k$ आकार के समूहों $n_1, n_2, \\ldots, n_k$ ($\\sum n_i = n$ के साथ) में विभाजित करने के तरीकों की संख्या: • यदि समूह **अलग-अलग पहचाने जाने योग्य** हैं: $\\dfrac{n!}{n_1!\\,n_2!\\cdots n_k!}$। • यदि समूह **समान** हैं और सभी आकार समान हैं $m$ (तो $n = km$): $\\dfrac{n!}{(m!)^k \\cdot k!}$।',
          },
        },
        {
          type: 'theorem',
          name: {
            english: 'Number of non-negative integer solutions',
        hindi: 'गैर-नकारात्मक पूर्णांक समाधानों की संख्या',
          },
          statement: {
            english: `The number of non-negative integer solutions of $x_1 + x_2 + \\ldots + x_k = n$ is $\\binom{n + k - 1}{k - 1}$ (**stars and bars**).
For positive integer solutions ($x_i \\ge 1$), it is $\\binom{n - 1}{k - 1}$.`,
            hindi: '$x_1 + x_2 + \\ldots + x_k = n$ के गैर-नकारात्मक पूर्णांक समाधानों की संख्या $\\binom{n + k - 1}{k - 1}$ (**तारे और बार**) है। धनात्मक पूर्णांक समाधान ($x_i \\ge 1$) के लिए, यह $\\binom{n - 1}{k - 1}$ है।',
          },
        },
        {
          type: 'example',
          number: 5,
          problem: {
            english: 'In how many ways can 10 identical balls be distributed in 4 distinct boxes?',
        hindi: '10 समान गेंदों को 4 अलग-अलग बक्सों में कितने तरीकों से वितरित किया जा सकता है?',
          },
          solution: {
            english: '$\\binom{10 + 4 - 1}{4 - 1} = \\binom{13}{3} = 286$.',
        hindi: '$\\binom{10 + 4 - 1}{4 - 1} = \\binom{13}{3} = 286$.',
          },
        },
        {
          type: 'example',
          number: 6,
          problem: {
            english: 'In how many ways can a deck of 52 cards be divided equally among 4 players?',
        hindi: '52 पत्तों के एक डेक को 4 खिलाड़ियों के बीच कितने तरीकों से समान रूप से विभाजित किया जा सकता है?',
          },
          solution: {
            english: 'Players are distinct; each gets 13 cards. $\\dfrac{52!}{(13!)^4}$.',
        hindi: 'खिलाड़ी अलग हैं; प्रत्येक को 13 कार्ड मिलते हैं। $\\dfrac{52!}{(13!)^4}$.',
          },
        },
      ],
    },
    {
      id: 'restrictions',
      title: {
        english: 'Permutations with Restrictions',
        hindi: 'प्रतिबन्ध सहित क्रमचय',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Two specified objects always together**: treat them as one unit. Arrangements $= (n-1)! \\cdot 2!$.',
        hindi: '**दो निर्दिष्ट वस्तुएं हमेशा एक साथ**: उन्हें एक इकाई के रूप में मानें। व्यवस्थाएँ $= (n-1)! \\cdot 2!$.',
            },
            {
              english: '**Two specified objects never together**: total $-$ together $= n! - (n-1)! \\cdot 2!$.',
        hindi: '**दो निर्दिष्ट वस्तुएं कभी एक साथ नहीं**: कुल $-$ एक साथ $= n! - (n-1)! \\cdot 2!$।',
            },
            {
              english: '**Gap method**: arrange the "free" $m$ objects first ($m!$ ways), creating $m+1$ gaps, then place the restricted $r$ objects in these gaps ($^{m+1}P_r$).',
        hindi: '**गैप विधि**: पहले "मुक्त" $m$ ऑब्जेक्ट्स को व्यवस्थित करें ($m!$ तरीकों से), $m+1$ अंतराल बनाएं, फिर प्रतिबंधित $r$ ऑब्जेक्ट्स को इन अंतरालों में रखें ($^{m+1}P_r$)।',
            },
          ],
        },
        {
          type: 'example',
          number: 7,
          problem: {
            english: 'In how many ways can letters of EQUATION be arranged so that all vowels come together?',
        hindi: 'समीकरण के अक्षरों को कितने तरीकों से व्यवस्थित किया जा सकता है ताकि सभी स्वर एक साथ आ जाएं?',
          },
          solution: {
            english: 'Vowels: E, U, A, I, O (5). Consonants: Q, T, N (3). Treat 5 vowels as one block ⇒ 4 units ⇒ $4!$. Vowels among themselves $= 5!$. Total $= 4! \\cdot 5! = 24 \\cdot 120 = 2880$.',
        hindi: 'स्वर: ई, यू, ए, आई, ओ (5)। व्यंजन: क्यू, टी, एन (3)। 5 स्वरों को एक ब्लॉक मानें ⇒ 4 इकाइयाँ ⇒ $4!$। आपस में स्वर $= 5!$। कुल $= 4! \\cdot 5! = 24 \\cdot 120 = 2880$.',
          },
        },
        {
          type: 'example',
          number: 8,
          problem: {
            english: 'How many words can be formed using letters of FAILURE so that consonants are never together?',
        hindi: 'FAILURE के अक्षरों का उपयोग करके कितने शब्द बनाए जा सकते हैं ताकि व्यंजन कभी भी एक साथ न हों?',
          },
          solution: {
            english: `Vowels: A, I, U, E (4); consonants: F, L, R (3).
Arrange vowels first: $4!$ ways → 5 gaps. Place 3 consonants in 5 gaps: $^5P_3 = 60$. Total $= 24 \\cdot 60 = 1440$.`,
            hindi: 'स्वर: ए, आई, यू, ई (4); व्यंजन: एफ, एल, आर (3)। पहले स्वरों को व्यवस्थित करें: $4!$ तरीके → 5 अंतराल। 3 व्यंजन को 5 अंतराल में रखें: $^5P_3 = 60$। कुल $= 24 \\cdot 60 = 1440$.',
          },
        },
      ],
    },
    {
      id: 'derangements',
      title: {
        english: 'Derangements & Inclusion-Exclusion',
        hindi: 'विपथन और समावेश-अपवर्जन',
      },
      blocks: [
        {
          type: 'definition',
          term: {
            english: 'Derangement',
        hindi: 'अव्यवस्था',
          },
          body: {
            english: 'A **derangement** of $n$ objects is a permutation in which **no** object appears in its original position. Number of derangements:',
        hindi: '$n$ ऑब्जेक्ट का **अव्यवस्था** एक क्रमपरिवर्तन है जिसमें **कोई** ऑब्जेक्ट अपनी मूल स्थिति में दिखाई नहीं देता है। विक्षोभों की संख्या:',
          },
        },
        {
          type: 'equation',
          latex: 'D_n = n!\\sum_{k=0}^{n} \\dfrac{(-1)^k}{k!} = n!\\left(1 - \\dfrac{1}{1!} + \\dfrac{1}{2!} - \\dfrac{1}{3!} + \\ldots + \\dfrac{(-1)^n}{n!}\\right)',
        },
        {
          type: 'list',
          items: [
            {
              english: '$D_1 = 0,\\ D_2 = 1,\\ D_3 = 2,\\ D_4 = 9,\\ D_5 = 44,\\ D_6 = 265$.',
        hindi: '$D_1 = 0,\\ D_2 = 1,\\ D_3 = 2,\\ D_4 = 9,\\ D_5 = 44,\\ D_6 = 265$.',
            },
          ],
        },
        {
          type: 'theorem',
          name: {
            english: 'Inclusion-Exclusion (PIE)',
        hindi: 'समावेशन-बहिष्करण (PIE)',
          },
          statement: {
            english: '$|A_1 \\cup A_2 \\cup \\ldots \\cup A_n| = \\sum |A_i| - \\sum |A_i \\cap A_j| + \\sum |A_i \\cap A_j \\cap A_k| - \\ldots + (-1)^{n+1}|A_1 \\cap \\ldots \\cap A_n|$.',
        hindi: '$|A_1 \\cup A_2 \\cup \\ldots \\cup A_n| = \\sum |A_i| - \\sum |A_i \\cap A_j| + \\sum |A_i \\cap A_j \\cap A_k| - \\ldots + (-1)^{n+1}|A_1 \\cap \\ldots \\cap A_n|$.',
          },
        },
        {
          type: 'example',
          number: 9,
          problem: {
            english: '5 letters and 5 envelopes are addressed. In how many ways can all letters be put in wrong envelopes?',
        hindi: '5 पत्र और 5 लिफाफे संबोधित हैं। कितने तरीकों से सभी पत्रों को गलत लिफाफे में रखा जा सकता है?',
          },
          solution: {
            english: '$D_5 = 44$.',
        hindi: '$D_5 = 44$।',
          },
        },
      ],
    },
    {
      id: 'misc',
      title: {
        english: 'Useful Standard Counts',
        hindi: 'उपयोगी मानक गणनाएँ',
      },
      blocks: [
        {
          type: 'table',
          headers: ['Quantity', 'Formula'],
          rows: [
            ['Number of subsets of an $n$-set', '$2^n$'],
            ['Number of subsets of size $r$', '$\\binom{n}{r}$'],
            ['Number of diagonals of a convex $n$-gon', '$\\binom{n}{2} - n = \\dfrac{n(n-3)}{2}$'],
            ['Number of triangles by joining $n$ points (no 3 collinear)', '$\\binom{n}{3}$'],
            ['Number of straight lines from $n$ points (no 3 collinear)', '$\\binom{n}{2}$'],
            ['Rectangles in $m \\times n$ grid (lines)', '$\\binom{m+1}{2}\\binom{n+1}{2}$'],
            ['Squares in $n \\times n$ grid', '$1^2 + 2^2 + \\ldots + n^2$'],
          ],
        },
      ],
    },
  ],
  keyFormulas: [
    {
      latex: '^nP_r = \\dfrac{n!}{(n-r)!}',
      desc: {
        english: 'Permutation',
        hindi: 'क्रमपरिवर्तन',
      },
    },
    {
      latex: '^nC_r = \\dfrac{n!}{r!(n-r)!}',
      desc: {
        english: 'Combination',
        hindi: 'संयोजन',
      },
    },
    {
      latex: '^nP_r = r! \\cdot ^nC_r',
      desc: {
        english: 'Linking identity',
        hindi: 'पहचान लिंक करना',
      },
    },
    {
      latex: '\\text{Arrangements with repeats} = \\dfrac{n!}{p!\\,q!\\,\\ldots}',
      desc: {
        english: 'Like objects',
        hindi: 'वस्तुओं की तरह',
      },
    },
    {
      latex: '\\text{Circular} = (n-1)!',
      desc: {
        english: 'Round table',
        hindi: 'गोल मेज़',
      },
    },
    {
      latex: '\\binom{n+k-1}{k-1}',
      desc: {
        english: 'Stars and bars (non-neg)',
        hindi: 'सितारे और बार (गैर-नकारात्मक)',
      },
    },
    {
      latex: 'D_n = n!\\sum_{k=0}^{n}\\dfrac{(-1)^k}{k!}',
      desc: {
        english: 'Derangements',
        hindi: 'अव्यवस्थाएं',
      },
    },
    {
      latex: '^nC_0 + ^nC_1 + \\ldots + ^nC_n = 2^n',
      desc: {
        english: 'Total subsets',
        hindi: 'कुल उपसमुच्चय',
      },
    },
  ],
  pyqs: [
    {
      year: 2023,
      exam: 'JEE Main',
      tag: 'Combinations',
      problem: {
        english: 'A committee of 7 is to be formed from 6 men and 4 women such that it has at least 3 women. The number of ways is:',
        hindi: '6 पुरुषों और 4 महिलाओं से 7 लोगों की एक समिति बनाई जानी है ताकि इसमें कम से कम 3 महिलाएं हों। तरीकों की संख्या है:',
      },
      answer: {
        english: '$176$',
        hindi: '$176$',
      },
      solution: {
        english: 'Cases (W, M): (3, 4), (4, 3). $\\binom{4}{3}\\binom{6}{4} + \\binom{4}{4}\\binom{6}{3} = 4 \\cdot 15 + 1 \\cdot 20 = 60 + 20 = 80 + 96 = 176$ (after totalling).',
        hindi: 'मामले (W, M): (3, 4), (4, 3)। $\\binom{4}{3}\\binom{6}{4} + \\binom{4}{4}\\binom{6}{3} = 4 \\cdot 15 + 1 \\cdot 20 = 60 + 20 = 80 + 96 = 176$ (योग करने पर)।',
      },
    },
    {
      year: 2022,
      exam: 'JEE Main',
      tag: 'Arrangements',
      problem: {
        english: 'Number of ways letters of word ARRANGE can be arranged so that two R\'s come together but two A\'s do not is:',
        hindi: 'ARRANGE शब्द के अक्षरों को कितने तरीकों से व्यवस्थित किया जा सकता है ताकि दो R एक साथ आएं लेकिन दो A एक साथ न आएं:',
      },
      answer: {
        english: '$240$',
        hindi: '$240$',
      },
      solution: {
        english: 'Treat RR as block; 6 units (RR, A, A, N, G, E) → $\\dfrac{6!}{2!}$ (two A\'s alike) $= 360$. Subtract cases where AA also together: 5 units → $5! = 120$. Answer $= 360 - 120 = 240$.',
        hindi: 'आरआर को ब्लॉक मानें; 6 इकाइयाँ (आरआर, ए, ए, एन, जी, ई) → $\\dfrac{6!}{2!}$ (दो A एक जैसे) $= 360$। उन मामलों को घटाएँ जहाँ AA भी एक साथ हो: 5 इकाइयाँ → $5! = 120$। उत्तर $= 360 - 120 = 240$.',
      },
    },
    {
      year: 2021,
      exam: 'JEE Main',
      tag: 'Distribution',
      problem: {
        english: 'Number of ways of distributing 8 identical chocolates among 3 children so that each gets at least one is:',
        hindi: '3 बच्चों के बीच 8 एक जैसी चॉकलेट बांटने के तरीकों की संख्या है ताकि प्रत्येक को कम से कम एक मिले:',
      },
      answer: {
        english: '$21$',
        hindi: '$21$',
      },
      solution: {
        english: 'Positive solutions of $x_1 + x_2 + x_3 = 8$: $\\binom{7}{2} = 21$.',
        hindi: '$x_1 + x_2 + x_3 = 8$ का सकारात्मक समाधान: $\\binom{7}{2} = 21$.',
      },
    },
    {
      year: 2020,
      exam: 'JEE Main',
      tag: 'Geometry counting',
      problem: {
        english: 'How many triangles can be formed from 12 points, of which 7 are collinear?',
        hindi: '12 बिंदुओं से कितने त्रिभुज बनाए जा सकते हैं, जिनमें से 7 संरेख हैं?',
      },
      answer: {
        english: '$\\binom{12}{3} - \\binom{7}{3} = 220 - 35 = 185$',
        hindi: '$\\binom{12}{3} - \\binom{7}{3} = 220 - 35 = 185$',
      },
      solution: {
        english: 'All triples minus the degenerate (collinear) triples.',
        hindi: 'सभी त्रिगुणों में से पतित (कोलीनियर) त्रिगुणों को घटा दिया जाता है।',
      },
    },
    {
      year: 2019,
      exam: 'JEE Advanced',
      tag: 'Derangement',
      problem: {
        english: 'Number of permutations of 1, 2, 3, 4, 5 such that no number is in its natural position is:',
        hindi: '1, 2, 3, 4, 5 के क्रमपरिवर्तन की संख्या ऐसी है कि कोई भी संख्या अपनी प्राकृतिक स्थिति में नहीं है:',
      },
      answer: {
        english: '$D_5 = 44$',
        hindi: '$D_5 = 44$',
      },
      solution: {
        english: 'Direct application of the derangement formula.',
        hindi: 'विव्यवस्था सूत्र का प्रत्यक्ष अनुप्रयोग।',
      },
    },
  ],
  next: {
    slug: 'trigonometric-ratios-identities',
    title: 'Trigonometric Ratios & Identities',
  },
};

export default chapter;
